import React, { useRef } from "react";
import { Box, makeStyles } from "@material-ui/core";
import { GoogleAutoComplete } from "ui/googleAutoComplete/GoogleAutoComplete";
import { RoundedInput } from "ui/roundedInput/RoundedInput";
import LocationIcon from "./assets/locationIcon.svg";
import { useFormikContext, Field } from "formik";
import theme from "theme";

type ConnectedAdressInputProps = {
  autoFocusField: boolean;
  disabled: boolean;
  vertical: boolean;
  children?: React.ReactNode;
  id: string;
  toggleInputFocus: () => void;
  size: "small" | undefined;
};

const ConnectedAdressInput: React.FunctionComponent<ConnectedAdressInputProps> = ({
  autoFocusField,
  disabled,
  children,
  vertical,
  id,
  toggleInputFocus,
  size,
}) => {
  const classes = useStyle();
  const { setFieldValue } = useFormikContext();

  const addressInputRef = useRef(null);

  const getGoogleField = (address, fieldName) => {
    return address.address_components.find((component) => component.types.includes(fieldName))?.long_name;
  };

  const handleChangeAddress = (address) => {
    if (address.address_components) {
      setFieldValue("address_input_text", address.formatted_address);
      setFieldValue("full_address", address.formatted_address);
      setFieldValue("street_number", getGoogleField(address, "street_number"));
      setFieldValue("street", getGoogleField(address, "route"));
      setFieldValue("zipcode", getGoogleField(address, "postal_code"));
      setFieldValue("city", getGoogleField(address, "locality"));
    }
  };

  return (
    <div ref={addressInputRef}>
      <Box display={vertical ? "block" : "flex"} alignItems={"center"} textAlign={"center"} width={"100%"}>
        {
          //here we have to pass the id props because we have two occurrences of Google input on the catalog page
        }
        <Box height={theme.spacing(size === "small" ? 5 : 7)} width="100%">
          <GoogleAutoComplete onChange={handleChangeAddress} id={id}>
            <Field
              autoFocus={autoFocusField} //eslint-disable-line
              type="text"
              name="address_input_text"
              disabled={disabled}
              component={SearchInput}
              placeholder={vertical ? "Votre adresse" : "Saisissez votre adresse"}
              className={classes.input}
              onFocus={toggleInputFocus}
              onBlur={toggleInputFocus}
            />
          </GoogleAutoComplete>
        </Box>
        {children}
      </Box>
    </div>
  );
};

const SearchInput = ({ ...props }) => {
  const classes = useStyle();
  return (
    <RoundedInput
      {...props}
      defaultValue={props.field.value}
      InputProps={{
        className: classes.input,
        endAdornment: <LocationIcon width={28} />,
      }}
    />
  );
};

const useStyle = makeStyles((theme) => ({
  input: {
    width: "100%",
    height: "inherit",
    WebkitTextFillColor: theme.palette.grey700.main,
  },
}));

export default ConnectedAdressInput;
